import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import './SocialIcons.css';
import Footer from './Footer'; 
import VisitModal from './VisitModal';
import ErrorBoundary from './utils/ErrorBoundary';

import About from './About';     
import Contact from './Contact';  
import Events from './Events';    
import LandingPage from './LandingPage'; 

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'auto';
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = 'auto';
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    closeMenu();
    // Use setTimeout to ensure the menu closes before navigation
    setTimeout(() => {
      window.location.href = e.target.href;
    }, 300);
  };

  const openModal = () => {
    setIsModalOpen(true);
    closeMenu();
  };

  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    // Handle scrolling effects
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolling(true); 
      } else {
        setScrolling(false); 
      }
      
      // Check if user is near footer to hide social icons
      const footerElement = document.querySelector('footer');
      const htmlElement = document.documentElement;
      
      if (footerElement) {
        const footerPosition = footerElement.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        
        // If footer is within 100px of viewport, add 'near-footer' class
        if (footerPosition - windowHeight < 100) {
          htmlElement.classList.add('near-footer');
        } else {
          htmlElement.classList.remove('near-footer');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    // Initial check
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Router>
      <ErrorBoundary>
        <div>
          {/* Header Section */}
          <header className={scrolling ? 'scrolled' : ''}>
            <div className="logo">
              <h2>Faith Tabernacle Church</h2>
            </div>

            {/* Hamburger Icon for Mobile */}
            <div className="hamburger" onClick={toggleMenu}>
              {isMenuOpen ? '×' : '☰'}
            </div>

            {/* Navigation Links */}
            <nav>
              <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                <li><a href="/" onClick={handleLinkClick}>Home</a></li>
                <li><a href="/about" onClick={handleLinkClick}>About</a></li>
                <li><a href="/contact" onClick={handleLinkClick}>Contact Us</a></li>
                <li><a href="/events" onClick={handleLinkClick}>Events</a></li>
                <li className="plan-visit-mobile">
                  <button onClick={openModal}>Plan a Visit</button>
                </li>
              </ul>
            </nav>

            {/* Plan a Visit Button - Positioned outside nav for desktop, hidden on mobile */}
            <div className="plan-visit-button">
              <button onClick={openModal}>Plan a Visit</button>
            </div>

            {/* Social Icons - Moved outside of navigation */}
            <div className="header-social-container mobile-only-social">
              <a href="https://www.facebook.com/ftckettering/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src="/facebook.png" alt="Facebook" />
              </a>
              <a href="https://www.instagram.com/ftckettering/" target="_blank" rel="noopener noreferrer" className="social-icon instagram-icon">
                <div className="instagram-gradient"></div>
                <img src="/instagram.png" alt="Instagram" />
              </a>
            </div>
          </header>

          {/* Routes for different pages */}
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/events" element={<Events />} />
            {/* Catch-all route - redirects any unknown paths to home page */}
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>

          <VisitModal isOpen={isModalOpen} onClose={closeModal} />

          {/* Footer Section */}
          <Footer />
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;
